import React, { useState, useEffect } from "react";
import { Menu, Dropdown, Badge, Avatar, List } from "antd";
import {
	MailOutlined,
	BellOutlined,
	WarningOutlined,
	CheckCircleOutlined,
	UserOutlined,
} from "@ant-design/icons";
import Flex from "components/shared-components/Flex";
import { PUBLIC_PREFIX_PATH } from "configs/AppConfig";
import { connect } from "react-redux";
import notificacaoService from "services/NotificacaoService";
import { useHistory } from "react-router-dom";
import moment from "moment";
import "moment/locale/pt-br";

moment.locale("pt-br");

const getIcon = (icon) => {
	switch (icon) {
		case "mail":
			return <MailOutlined />;
		case "alert":
			return <WarningOutlined />;
		case "check":
			return <CheckCircleOutlined />;
		case "user":
			return <UserOutlined />;
		default:
			return <MailOutlined />;
	}
};

const formatNotificationTime = (time) => {
	const now = moment();
	const notificationTime = moment(time);
	const diffHours = now.diff(notificationTime, "hours");

	// Se for nas últimas 24 horas, mostra apenas HH:mm
	if (diffHours < 24) {
		return notificationTime.format("HH:mm");
	}

	// Se for mais antigo, mostra o dia completo
	return notificationTime.format("HH:mm [em] DD [de] MMMM");
};

const getNotificationBody = (list, history) => {
	return list.length > 0 ? (
		<List
			size="small"
			itemLayout="horizontal"
			dataSource={list}
			renderItem={(item) => (
				<List.Item
					className={`list-clickable ${
						!item.visualizada ? "notification-unread" : ""
					}`}
					onClick={() => {
						if (item.url) {
							let path = item.url.replace(/^\/#/, "");
							// HashRouter não gera location.key e um history.push
							// para a MESMA url não muda o location — telas que
							// reagem a ?query (ex.: ?tab= do dashboard) não
							// re-disparariam ao re-clicar a notificação já estando
							// na tela. Nonce força um location novo a cada clique.
							path +=
								(path.includes("?") ? "&" : "?") +
								"_n=" +
								Date.now();
							history.push(path);
						}
					}}
				>
					<Flex alignItems="center">
						<div className="pr-3">
							{item.img ? (
								<Avatar
									src={`${PUBLIC_PREFIX_PATH}/img/avatars/${item.img}`}
								/>
							) : (
								<Avatar
									className={`ant-avatar-${item.type}`}
									icon={getIcon(item.icon)}
								/>
							)}
						</div>
						<div className="mr-3">
							<span className="font-weight-bold text-dark">
								{item.name}{" "}
							</span>
							<span className="text-gray-light">{item.desc}</span>
						</div>
						<small className="ml-auto">
							{formatNotificationTime(item.time)}
						</small>
					</Flex>
				</List.Item>
			)}
		/>
	) : (
		<div className="empty-notification">
			<img
				src="https://gw.alipayobjects.com/zos/rmsportal/sAuJeJzSKbUmHfBQRzmZ.svg"
				alt="empty"
			/>
			<p className="mt-3">Você já viu todas as notificações</p>
		</div>
	);
};

export const NavNotification = ({ notificacoes }) => {
	const [visible, setVisible] = useState(false);
	const [data, setData] = useState(notificacoes);
	const history = useHistory();

	// Atualizar dados quando notificações mudarem
	useEffect(() => {
		setData(notificacoes);
	}, [notificacoes]);

	const handleVisibleChange = async (flag) => {
		setVisible(flag);

		// Quando fechar o menu, marcar todas como visualizadas
		if (!flag && data.length > 0) {
			try {
				await notificacaoService.visualizarTodas();
				// Zerar as notificações no front
				setData(
					data.map((notificacao) => ({
						...notificacao,
						visualizada: true,
					})),
				);
			} catch (error) {
				console.error(
					"Erro ao marcar notificações como visualizadas:",
					error,
				);
			}
		}
	};

	const notificationList = (
		<div className="nav-dropdown nav-notification">
			<div className="nav-notification-header d-flex justify-content-between align-items-center">
				<h4 className="mb-0">Notificações</h4>
			</div>
			<div className="nav-notification-body">
				{getNotificationBody(data, history)}
			</div>
			{data.length > 0 ? (
				<div className="nav-notification-footer">
					<a
						className="d-block"
						href="#/"
						onClick={(e) => {
							e.preventDefault();
							setVisible(false);
							history.push("/app/lista-notificacoes");
						}}
					>
						Ver todas
					</a>
				</div>
			) : null}
		</div>
	);

	return (
		<Dropdown
			placement="bottomRight"
			overlay={notificationList}
			onVisibleChange={handleVisibleChange}
			visible={visible}
			trigger={["click"]}
			className="nav-notification-dropdown"
		>
			<Menu
				mode="horizontal"
				selectable={true}
				selectedKeys={visible ? ["notification"] : []}
			>
				<Menu.Item key="notification">
					<Badge
						count={
							data.filter(
								(notificacao) => !notificacao.visualizada,
							).length
						}
					>
						<BellOutlined
							className="nav-icon mx-auto"
							type="bell"
							style={{ color: "#000" }}
						/>
					</Badge>
				</Menu.Item>
			</Menu>
		</Dropdown>
	);
};

const mapStateToProps = ({ menu }) => {
	return {
		notificacoes: menu.notificacoes,
	};
};

export default connect(mapStateToProps, null)(NavNotification);
